(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vsdmx-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (!root || root.dataset.vsdmxInitialised === 'true') return;
    root.dataset.vsdmxInitialised = 'true';

    const menuButton = root.querySelector('.menu-button');
    const menuPanel = root.querySelector('.menu-panel');
    const closeMenu = () => {
      if (!menuPanel || !menuButton) return;
      menuPanel.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    };
    menuButton?.addEventListener('click', () => {
      const willOpen = menuPanel.hidden;
      menuPanel.hidden = !willOpen;
      menuButton.setAttribute('aria-expanded', String(willOpen));
    });
    menuPanel?.addEventListener('click', closeMenu);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motionSections = root.querySelectorAll('[data-motion]');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      motionSections.forEach((section) => section.classList.add('is-inview'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-inview'); });
      }, { threshold: 0.22 });
      motionSections.forEach((section) => observer.observe(section));
    }

    const heroProduct = root.querySelector('.product-object');
    const featureFolds = [...root.querySelectorAll('.feature-fold')];
    const foldCounter = root.querySelector('.fold-counter');
    const currentFeature = root.querySelector('[data-feature-current]');
    const featureIndex = root.querySelector('.feature-index');
    let scrollFrame;
    const renderMotion = () => {
      const rootTop = root.getBoundingClientRect().top + window.scrollY;
      const localScroll = Math.max(0, window.scrollY - rootTop);
      const progress = Math.min(1, localScroll / (window.innerHeight * 0.85));
      if (!reducedMotion && heroProduct) {
        heroProduct.style.setProperty('--hero-shift', `${progress * 34}vw`);
        heroProduct.style.setProperty('--hero-scale', String(1 - progress * 0.11));
        heroProduct.style.setProperty('--hero-opacity', String(1 - progress * 0.38));
      }
      const viewportCentre = window.innerHeight / 2;
      let activeIndex = 0;
      let closestDistance = Infinity;
      featureFolds.forEach((fold, index) => {
        const rect = fold.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - viewportCentre);
        if (distance < closestDistance) { closestDistance = distance; activeIndex = index; }
        if (!reducedMotion) {
          const parallax = Math.max(-18, Math.min(18, (rect.top + rect.height / 2 - viewportCentre) * -0.035));
          fold.querySelector('.feature-media')?.style.setProperty('--media-y', `${parallax}px`);
        }
      });
      const inFeatureArea = localScroll >= window.innerHeight * 0.72 && (!featureIndex || featureIndex.getBoundingClientRect().top > window.innerHeight * 0.35);
      foldCounter?.classList.toggle('is-visible', inFeatureArea);
      if (currentFeature) currentFeature.textContent = String(activeIndex + 1).padStart(2, '0');
      foldCounter?.style.setProperty('--fold-progress', `${((activeIndex + 1) / featureFolds.length) * 100}%`);
      scrollFrame = null;
    };
    window.addEventListener('scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(renderMotion); }, { passive: true });
    renderMotion();

    if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      root.querySelectorAll('[data-tilt]').forEach((card) => {
        card.addEventListener('pointermove', (event) => {
          const bounds = card.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          card.style.setProperty('--rx', `${-y * 3.5}deg`);
          card.style.setProperty('--ry', `${x * 4.5}deg`);
        });
        card.addEventListener('pointerleave', () => {
          card.style.setProperty('--rx', '0deg');
          card.style.setProperty('--ry', '0deg');
        });
      });
    }
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-vsdmx-page]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
